import {NavigateOptions, useNavigate} from 'react-router-dom';
import {resolvePath} from '@/utils/channel';
import {resendWebUvLogIfSamePath} from '@/utils/logger/event';

type QueryParams = Record<string, string | number | boolean | undefined | null>;

/**
 * React Router navigate를 name + params로 사용할 수 있도록 래핑한 훅
 */
export const useNamedNavigate = () => {
  const navigate = useNavigate();

  return (
    pathTemplate: string,
    params: Record<string, string | number> = {},
    options: NavigateOptions = {},
    query: QueryParams = {},
  ) => {
    let to = resolvePath(pathTemplate, params);

    if (query && Object.keys(query).length > 0) {
      const searchParams = new URLSearchParams();
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      });
      to += `?${searchParams.toString()}`;
    }
    resendWebUvLogIfSamePath(to);

    navigate(to, options);
  };
};
